import React from 'react';

const ContentLibraryLabel = ({ hasLinkedElements }) => (
  <>
    {hasLinkedElements
      ? t('settings.tab.roles.edit.image_and_content_library_label')
      : t('settings.tab.roles.edit.image_library_label')}
  </>
);

export default ContentLibraryLabel;
